import {
    FETCH_ALL_CONTENT_SUCCESS, EDIT_CONTENT, UPDATE_CONTENT_SUCCESS, CREATE_CONTENT_SUCCESS, DELETE_CONTENT_SUCCESS,SET_CONTENT
} from "constants/contents.constants";

const INIT_STATE = {
    contents: [],
    content: {
        id: 0,
        name: '',
        country_id: 0,
        langs: [],
        country: null,
        value: "",
        mentionData: null,
        content_type_id:0
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        //start content
        case SET_CONTENT: {
            let c = Object.assign({}, state.content);
            c[action.key] = action.value
            return {
                ...state,
                content: c
            }
        }
        case FETCH_ALL_CONTENT_SUCCESS: {
            return {
                ...state,
                contents: action.payload.data
            }
        }

        case UPDATE_CONTENT_SUCCESS: {
            let foundIndex = state.contents.findIndex(x => x.id === action.payload.data.id);
            let all = Object.assign([], state.contents);
            all[foundIndex] = action.payload.data
            return {
                ...state,
                contents: all,
                content: getEditContent(INIT_STATE,action.payload.data) 
            }
        }

        case CREATE_CONTENT_SUCCESS: {
            let all = Object.assign([], state.contents);
            all.push(action.payload.data)
            return {
                ...state,
                contents: all,
                content: INIT_STATE.content
            }
        }

        case DELETE_CONTENT_SUCCESS: {
            let all = Object.assign([], state.contents);
            let newArray = all.filter(function (c) {
                return c.id !== action.payload.id
            });
            return {
                ...state,
                contents: newArray,
            }
        }

        case EDIT_CONTENT: {
            return {
                ...state,
                content: getEditContent(INIT_STATE,state.contents.find(c => c.id === action.payload))
            }
        }

        
        default:
            return state;
    }
}

function getEditContent(initobject, o) {
    initobject.id = o.id;
    initobject.name = o.name;
    initobject.content_type_id = o.content_type.id;
    initobject.country_id = o.country.id;
    initobject.country = o.country;
    initobject.contents = o.contents;
    for (const z of o.country.langs){
        initobject["value"+ z.id] = o.contents.find(c => c.language.id === z.id).content_text
    }

    return initobject
}